// ZSeriesFlow.js
// ─────────────────────────────────────────────────────────────────────────────
// Z Series Gearbox Flow  (ZDY / ZLY / ZSY / ZFY)
// Steps: Type → Size → Ratio → Assembly Type → Summary / Code
// ─────────────────────────────────────────────────────────────────────────────
import React, { useState, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

// ── Assets ───────────────────────────────────────────────────────────────────
import ZDYImg   from '../assets/Z/ZDY.png';
import ZLYImg   from '../assets/Z/ZLY.png';
import ZSYImg   from '../assets/Z/ZSY.png';
import ZFYImg   from '../assets/Z/ZFY.png';
import AstypeImg from '../assets/Z/Astype.png';

// ─────────────────────────────────────────────────────────────────────────────
// Data Tables
// ─────────────────────────────────────────────────────────────────────────────
const Z_TYPES = [
  { key: 'ZDY', label: 'ZDY', img: ZDYImg },
  { key: 'ZLY', label: 'ZLY', img: ZLYImg },
  { key: 'ZSY', label: 'ZSY', img: ZSYImg },
  { key: 'ZFY', label: 'ZFY', img: ZFYImg },
];

const SIZES = {
  ZDY: [80,100,125,160,200,250,280,315,355,400,450,500,560],
  ZLY: [112,125,140,160,180,200,224,250,280,315,355,400,450,500,560,630,710],
  ZSY: [160,180,200,224,250,280,315,355,400,450,500,560,630,710],
  ZFY: [180,200,224,250,280,315,355,400,450,500,560,630,710,800],
};

// ZDY Ratios per size  (ZLY / ZSY / ZFY → placeholder แจ้ง TODO)
const RATIOS_ZDY = {
  80:  [1.25,1.4,1.6,1.8,2,2.24,2.5,2.8,3.15,3.55,4,4.5,5,5.6],
  100: [1.25,1.4,1.6,1.8,2,2.24,2.5,2.8,3.15,3.55,4,4.5,5,5.6],
  125: [1.25,1.4,1.6,1.8,2,2.24,2.5,2.8,3.15,3.55,4,4.5,5,5.6],
  160: [1.25,1.4,1.6,1.8,2,2.24,2.5,2.8,3.15,3.55,4,4.5,5,5.6],
  200: [1.25,1.4,1.6,1.8,2,2.24,2.5,2.8,3.15,3.55,4,4.5,5,5.6],
  250: [1.25,1.4,1.6,1.8,2,2.24,2.5,2.8,3.15,3.55,4,4.5,5,5.6],
  280: [1.6,1.8,2,2.24,2.5,2.8,3.15,3.55,4,4.5,5,5.6],
  315: [1.6,1.8,2,2.24,2.5,2.8,3.15,3.55,4,4.5,5,5.6],
  355: [1.6,1.8,2,2.24,2.5,2.8,3.15,3.55,4,4.5,5,5.6],
  400: [2,2.24,2.5,2.8,3.15,3.55,4,4.5,5,5.6],
  450: [2,2.24,2.5,2.8,3.15,3.55,4,4.5,5,5.6],
  500: [2,2.24,2.5,2.8,3.15,3.55,4,4.5,5,5.6],
  560: [2,2.24,2.5,2.8,3.15,3.55,4,4.5,5,5.6],
};

const RATIOS_ZLY = {
  112: [6.3, 7.1, 8, 9, 10, 11.2, 12.5, 14, 16, 18, 20],
  125: [6.3, 7.1, 8, 9, 10, 11.2, 12.5, 14, 16, 18, 20],
  140: [6.3, 7.1, 8, 9, 10, 11.2, 12.5, 14, 16, 18, 20],
  160: [6.3, 7.1, 8, 9, 10, 11.2, 12.5, 14, 16, 18, 20],
  180: [6.3, 7.1, 8, 9, 10, 11.2, 12.5, 14, 16, 18, 20],
  200: [6.3, 7.1, 8, 9, 10, 11.2, 12.5, 14, 16, 18, 20],
  224: [6.3, 7.1, 8, 9, 10, 11.2, 12.5, 14, 16, 18, 20],
  250: [6.3, 7.1, 8, 9, 10, 11.2, 12.5, 14, 16, 18, 20],
  280: [6.3, 7.1, 8, 9, 10, 11.2, 12.5, 14, 16, 18, 20],
  315: [6.3, 7.1, 8, 9, 10, 11.2, 12.5, 14, 16, 18, 20],
  355: [6.3, 7.1, 8, 9, 10, 11.2, 12.5, 14, 16, 18, 20],
  400: [6.3, 7.1, 8, 9, 10, 11.2, 12.5, 14, 16, 18, 20],
  450: [6.3, 7.1, 8, 9, 10, 11.2, 12.5, 14, 16, 18, 20],
  500: [6.3, 7.1, 8, 9, 10, 11.2, 12.5, 14, 16, 18, 20],
  560: [6.3, 7.1, 8, 9, 10, 11.2, 12.5, 14, 16, 18, 20],
  630: [6.3, 7.1, 8, 9, 10, 11.2, 12.5, 14, 16, 18, 20],
  710: [6.3, 7.1, 8, 9, 10, 11.2, 12.5, 14, 16, 18, 20],
};

const RATIOS_ZSY = {
  160: [22.4, 25, 28, 31.5, 35.5, 40, 45, 50, 56, 63, 71, 80, 90, 100],
  180: [22.4, 25, 28, 31.5, 35.5, 40, 45, 50, 56, 63, 71, 80, 90, 100],
  200: [22.4, 25, 28, 31.5, 35.5, 40, 45, 50, 56, 63, 71, 80, 90, 100],
  224: [22.4, 25, 28, 31.5, 35.5, 40, 45, 50, 56, 63, 71, 80, 90, 100],
  250: [22.4, 25, 28, 31.5, 35.5, 40, 45, 50, 56, 63, 71, 80, 90, 100],
  280: [22.4, 25, 28, 31.5, 35.5, 40, 45, 50, 56, 63, 71, 80, 90, 100],
  315: [22.4, 25, 28, 31.5, 35.5, 40, 45, 50, 56, 63, 71, 80, 90, 100],
  355: [22.4, 25, 28, 31.5, 35.5, 40, 45, 50, 56, 63, 71, 80, 90],
  400: [22.4, 25, 28, 31.5, 35.5, 40, 45, 50, 56, 63, 71, 80, 90],
  450: [22.4, 25, 28, 31.5, 35.5, 40, 45, 50, 56, 63, 71, 80, 90],
  500: [22.4, 25, 28, 31.5, 35.5, 40, 45, 50, 56, 63, 71, 80, 90],
  560: [22.4, 25, 28, 31.5, 35.5, 40, 45, 50, 56, 63, 71, 80, 90],
  630: [22.4, 25, 28, 31.5, 35.5, 40, 45, 50, 56, 63, 71, 80, 90],
  710: [22.4, 25, 28, 31.5, 35.5, 40, 45, 50, 56, 63, 71, 80, 90],
};

const RATIOS_ZFY = {
  180: [112, 125, 140, 160, 180, 200, 224, 250, 280, 315, 355, 400, 450, 500],
  200: [112, 125, 140, 160, 180, 200, 224, 250, 280, 315, 355, 400, 450, 500],
  224: [112, 125, 140, 160, 180, 200, 224, 250, 280, 315, 355, 400, 450, 500],
  250: [112, 125, 140, 160, 180, 200, 224, 250, 280, 315, 355, 400, 450, 500],
  280: [112, 125, 140, 160, 180, 200, 224, 250, 280, 315, 355, 400, 450, 500],
  315: [112, 125, 140, 160, 180, 200, 224, 250, 280, 315, 355, 400, 450, 500],
  355: [100, 112, 125, 140, 160, 180, 200, 224, 250, 280, 315, 355, 400, 450, 500],
  400: [100, 112, 125, 140, 160, 180, 200, 224, 250, 280, 315, 355, 400, 450, 500],
  450: [100, 112, 125, 140, 160, 180, 200, 224, 250, 280, 315, 355, 400, 450, 500],
  500: [100, 112, 125, 140, 160, 180, 200, 224, 250, 280, 315, 355, 400, 450, 500],
  560: [100, 112, 125, 140, 160, 180, 200, 224, 250, 280, 315, 355, 400, 450, 500],
  630: [100, 112, 125, 140, 160, 180, 200, 224, 250, 280, 315, 355, 400, 450, 500],
  710: [100, 112, 125, 140, 160, 180, 200, 224, 250, 280, 315, 355, 400, 450, 500],
};

const RATIOS_MAP = { ZDY: RATIOS_ZDY, ZLY: RATIOS_ZLY, ZSY: RATIOS_ZSY, ZFY: RATIOS_ZFY };

const ASSEMBLY_TYPES = ['I','II','III','IV','V','VI','VII','VIII','IX'];

// ─────────────────────────────────────────────────────────────────────────────
// PN (Nominal Input Power) lookup + Service Factor calculation
// ที่มา: ตาราง Nominal Power (P1N) จากเอกสาร Ratio.pdf ของแต่ละ Series
// โครงสร้าง: PN_XXX[ratio][size] = { 1500: kW|null, 1000: kW|null, 750: kW|null }
// ─────────────────────────────────────────────────────────────────────────────
export const PN_ZDY = {
  1.25: { 80:{1500:57,1000:40,750:31}, 100:{1500:103,1000:69,750:52}, 125:{1500:205,1000:140,750:105}, 160:{1500:360,1000:260,750:190}, 200:{1500:633,1000:446,750:348}, 250:{1500:1121,1000:807,750:636} },
  1.4: { 80:{1500:53,1000:37,750:29}, 100:{1500:96,1000:65,750:48}, 125:{1500:194,1000:132,750:102}, 160:{1500:326,1000:240,750:180}, 200:{1500:616,1000:433,750:337}, 250:{1500:1109,1000:794,750:624} },
  1.6: { 80:{1500:49,1000:34,750:27}, 100:{1500:92,1000:63,750:50}, 125:{1500:180,1000:125,750:98}, 160:{1500:310,1000:217,750:168}, 200:{1500:587,1000:410,750:319}, 250:{1500:1068,1000:760,750:595}, 280:{1500:1473,1000:1051,750:824}, 315:{1500:1996,1000:1430,750:1124}, 355:{1500:2766,1000:1992,750:1569} },
  1.8: { 80:{1500:45,1000:31,750:24}, 100:{1500:87,1000:62,750:48}, 125:{1500:173,1000:120,750:95}, 160:{1500:290,1000:206,750:160}, 200:{1500:557,1000:389,750:302}, 250:{1500:1024,1000:726,750:567}, 280:{1500:1411,1000:1002,750:784}, 315:{1500:1925,1000:1372,750:1074}, 355:{1500:2663,1000:1906,750:1497} },
  2: { 80:{1500:39,1000:27,750:21}, 100:{1500:80,1000:55,750:43}, 125:{1500:158,1000:110,750:85}, 160:{1500:278,1000:194,750:150}, 200:{1500:526,1000:367,750:284}, 250:{1500:970,1000:684,750:534}, 280:{1500:1339,1000:946,750:738}, 315:{1500:1827,1000:1296,750:1013}, 355:{1500:2536,1000:1806,750:1414}, 400:{1500:null,1000:2547,750:1999}, 450:{1500:null,1000:3578,750:2821}, 500:{1500:null,1000:4793,750:3775}, 560:{1500:null,1000:null,750:5169} },
  2.24: { 80:{1500:36,1000:25,750:19}, 100:{1500:70,1000:49,750:38}, 125:{1500:141,1000:98,750:76}, 160:{1500:264,1000:183,750:142}, 200:{1500:484,1000:337,750:262}, 250:{1500:914,1000:645,750:503}, 280:{1500:1236,1000:874,750:682}, 315:{1500:1711,1000:1207,750:941}, 355:{1500:2377,1000:1683,750:1314}, 400:{1500:null,1000:2402,750:1878}, 450:{1500:null,1000:3397,750:2667}, 500:{1500:null,1000:4512,750:3538}, 560:{1500:null,1000:null,750:4833} },
  2.5: { 80:{1500:32,1000:22,750:17}, 100:{1500:64,1000:45,750:35}, 125:{1500:127,1000:88,750:68}, 160:{1500:245,1000:170,750:132}, 200:{1500:447,1000:311,750:241}, 250:{1500:855,1000:601,750:468}, 280:{1500:1154,1000:812,750:633}, 315:{1500:1617,1000:1136,750:884}, 355:{1500:2264,1000:1596,750:1243}, 400:{1500:null,1000:2235,750:1742}, 450:{1500:null,1000:3185,750:2492}, 500:{1500:null,1000:4353,750:3406}, 560:{1500:null,1000:null,750:4645} },
  2.8: { 80:{1500:27,1000:19,750:15}, 100:{1500:53,1000:37,750:29}, 125:{1500:115,1000:80,750:62}, 160:{1500:224,1000:155,750:120}, 200:{1500:409,1000:284,750:220}, 250:{1500:789,1000:552,750:429}, 280:{1500:1063,1000:746,750:580}, 315:{1500:1489,1000:1048,750:816}, 355:{1500:2068,1000:1456,750:1134}, 400:{1500:null,1000:2049,750:1593}, 450:{1500:null,1000:2945,750:2296}, 500:{1500:null,1000:4000,750:3118}, 560:{1500:null,1000:null,750:4232} },
  3.15: { 80:{1500:23,1000:16,750:13}, 100:{1500:47,1000:33,750:25}, 125:{1500:96,1000:67,750:52}, 160:{1500:203,1000:140,750:109}, 200:{1500:375,1000:260,750:202}, 250:{1500:709,1000:496,750:385}, 280:{1500:990,1000:695,750:540}, 315:{1500:1359,1000:952,750:740}, 355:{1500:1924,1000:1352,750:1052}, 400:{1500:2658,1000:1817,750:1458}, 450:{1500:3790,1000:2681,750:2084}, 500:{1500:5036,1000:3607,750:2802}, 560:{1500:6666,1000:4807,750:3747} },
  3.55: { 80:{1500:20,1000:14,750:11}, 100:{1500:41,1000:28,750:22}, 125:{1500:85,1000:59,750:46}, 160:{1500:179,1000:124,750:96}, 200:{1500:337,1000:234,750:181}, 250:{1500:639,1000:446,750:346}, 280:{1500:898,1000:628,750:488}, 315:{1500:1210,1000:845,750:655}, 355:{1500:1730,1000:1210,750:940}, 400:{1500:2410,1000:1694,750:1312}, 450:{1500:3407,1000:2396,750:1856}, 500:{1500:4460,1000:3196,750:2483}, 560:{1500:6119,1000:4395,750:3419} },
  4: { 80:{1500:17,1000:12,750:9}, 100:{1500:34,1000:24,750:18}, 125:{1500:69,1000:48,750:37}, 160:{1500:155,1000:107,750:83}, 200:{1500:300,1000:208,750:161}, 250:{1500:570,1000:396,750:307}, 280:{1500:774,1000:539,750:418}, 315:{1500:1095,1000:764,750:590}, 355:{1500:1555,1000:1088,750:844}, 400:{1500:2146,1000:1501,750:1160}, 450:{1500:2981,1000:2090,750:1618}, 500:{1500:3985,1000:2833,750:2199}, 560:{1500:5651,1000:4033,750:3128} },
  4.5: { 80:{1500:14,1000:9.5,750:7}, 100:{1500:29,1000:20,750:15}, 125:{1500:55,1000:38,750:30}, 160:{1500:137,1000:95,750:73}, 200:{1500:260,1000:180,750:139}, 250:{1500:495,1000:344,750:266}, 280:{1500:703,1000:488,750:378}, 315:{1500:997,1000:694,750:536}, 355:{1500:1367,1000:953,750:738}, 400:{1500:1878,1000:1311,750:1015}, 450:{1500:2619,1000:1832,750:1416}, 500:{1500:3635,1000:2582,750:1997}, 560:{1500:4912,1000:3485,750:2694} },
  5: { 80:{1500:11,1000:8,750:6}, 100:{1500:25,1000:17,750:13}, 125:{1500:48,1000:33,750:26}, 160:{1500:121,1000:84,750:65}, 200:{1500:229,1000:159,750:123}, 250:{1500:451,1000:313,750:242}, 280:{1500:608,1000:422,750:326}, 315:{1500:864,1000:599,750:462}, 355:{1500:1179,1000:820,750:633}, 400:{1500:1680,1000:1168,750:900}, 450:{1500:2340,1000:1629,750:1257}, 500:{1500:3149,1000:2231,750:1724}, 560:{1500:4400,1000:3125,750:2418} },
  5.6: { 80:{1500:10,1000:7,750:5}, 100:{1500:20,1000:14,750:11}, 125:{1500:40,1000:27,750:21}, 160:{1500:109,1000:75,750:59}, 200:{1500:211,1000:146,750:113}, 250:{1500:389,1000:270,750:208}, 280:{1500:531,1000:368,750:285}, 315:{1500:779,1000:540,750:416}, 355:{1500:1031,1000:716,750:554}, 400:{1500:1564,1000:1088,750:838}, 450:{1500:2038,1000:1417,750:1092}, 500:{1500:2791,1000:1969,750:1519}, 560:{1500:3778,1000:2670,750:2061} },
};

export const PN_ZLY = {
  6.3: { 112:{1500:37.4,1000:26.4,750:19.5}, 125:{1500:54,1000:37.4,750:28.5}, 140:{1500:73,1000:50,750:28.5}, 160:{1500:114,1000:78,750:60}, 180:{1500:157,1000:109,750:84}, 200:{1500:221,1000:153,750:119}, 224:{1500:305,1000:211,750:163}, 250:{1500:424,1000:294,750:227}, 280:{1500:578,1000:400,750:308}, 315:{1500:791,1000:548,750:422}, 355:{1500:1156,1000:802,750:618}, 400:{1500:1650,1000:1146,750:884}, 450:{1500:2192,1000:1558,750:1213}, 500:{1500:3132,1000:2181,750:1685}, 560:{1500:4310,1000:3000,750:2320}, 630:{1500:null,1000:4347,750:3357}, 710:{1500:null,1000:6229,750:4884} },
  7.1: { 112:{1500:34,1000:24,750:17.7}, 125:{1500:49,1000:34,750:26}, 140:{1500:66,1000:45.5,750:35}, 160:{1500:104,1000:71,750:54.5}, 180:{1500:143,1000:99,750:76}, 200:{1500:201,1000:139,750:108}, 224:{1500:277,1000:192,750:148}, 250:{1500:385,1000:267,750:206}, 280:{1500:525,1000:364,750:280}, 315:{1500:719,1000:498,750:384}, 355:{1500:1051,1000:729,750:562}, 400:{1500:1500,1000:1042,750:804}, 450:{1500:1993,1000:1416,750:1103}, 500:{1500:2847,1000:1983,750:1532}, 560:{1500:3817,1000:2731,750:2109}, 630:{1500:null,1000:3952,750:3052}, 710:{1500:null,1000:5663,750:4440} },
  8: { 112:{1500:32,1000:21.5,750:17}, 125:{1500:43,1000:29.5,750:23}, 140:{1500:61,1000:42.4,750:33}, 160:{1500:94.5,1000:64,750:49}, 180:{1500:130,1000:93,750:69}, 200:{1500:181.5,1000:126,750:97}, 224:{1500:250,1000:173,750:133}, 250:{1500:347,1000:241,750:186}, 280:{1500:469,1000:325,750:251}, 315:{1500:678,1000:470,750:362}, 355:{1500:932,1000:646,750:498}, 400:{1500:1309,1000:908,750:700}, 450:{1500:1869,1000:1298,750:1000}, 500:{1500:2489,1000:1730,750:1333}, 560:{1500:3520,1000:2447,750:1887}, 630:{1500:null,1000:3398,750:2619}, 710:{1500:null,1000:5019,750:3881} },
  9: { 112:{1500:29,1000:20,750:15}, 125:{1500:38.5,1000:27,750:20.5}, 140:{1500:56,1000:38.5,750:30}, 160:{1500:81,1000:55,750:42}, 180:{1500:119,1000:82.5,750:64}, 200:{1500:165.5,1000:115,750:88}, 224:{1500:227,1000:157,750:121}, 250:{1500:315,1000:218,750:168}, 280:{1500:423,1000:293,750:226}, 315:{1500:612,1000:424,750:327}, 355:{1500:841,1000:583,750:449}, 400:{1500:1182,1000:819,750:631}, 450:{1500:1689,1000:1172,750:903}, 500:{1500:2248,1000:1561,750:1202}, 560:{1500:3183,1000:2210,750:1703}, 630:{1500:null,1000:3068,750:2363}, 710:{1500:null,1000:4537,750:3502} },
  10: { 112:{1500:26,1000:18,750:14}, 125:{1500:35,1000:24,750:18.5}, 140:{1500:50,1000:35,750:26.6}, 160:{1500:73,1000:50,750:38}, 180:{1500:109,1000:75,750:58}, 200:{1500:149,1000:103,750:80}, 224:{1500:204,1000:142,750:109}, 250:{1500:284,1000:197,750:152}, 280:{1500:383,1000:266,750:204}, 315:{1500:555,1000:384,750:296}, 355:{1500:762,1000:528,750:407}, 400:{1500:1070,1000:742,750:571}, 450:{1500:1530,1000:1061,750:817}, 500:{1500:2038,1000:1414,750:1088}, 560:{1500:2883,1000:2001,750:1541}, 630:{1500:null,1000:2777,750:2139}, 710:{1500:null,1000:4112,750:3172} },
  11.2: { 112:{1500:23,1000:16,750:12}, 125:{1500:31.5,1000:22,750:17}, 140:{1500:45,1000:31,750:24}, 160:{1500:66,1000:45,750:35}, 180:{1500:96,1000:67,750:51}, 200:{1500:133,1000:92,750:71}, 224:{1500:184,1000:127,750:98}, 250:{1500:255,1000:177,750:136}, 280:{1500:346,1000:240,750:185}, 315:{1500:500,1000:347,750:267}, 355:{1500:688,1000:477,750:367}, 400:{1500:966,1000:669,750:516}, 450:{1500:1381,1000:957,750:737}, 500:{1500:1839,1000:1275,750:982}, 560:{1500:2604,1000:1806,750:1391}, 630:{1500:null,1000:2506,750:1930}, 710:{1500:null,1000:3711,750:2862} },
  12.5: { 112:{1500:21,1000:14,750:11}, 125:{1500:28,1000:19.5,750:15}, 140:{1500:40,1000:28,750:21}, 160:{1500:59,1000:40,750:31}, 180:{1500:83,1000:57,750:44}, 200:{1500:116.5,1000:81,750:63}, 224:{1500:165,1000:114,750:88}, 250:{1500:229,1000:159,750:122}, 280:{1500:311,1000:216,750:166}, 315:{1500:450,1000:312,750:240}, 355:{1500:618,1000:428,750:330}, 400:{1500:869,1000:601,750:463}, 450:{1500:1242,1000:860,750:663}, 500:{1500:1654,1000:1146,750:882}, 560:{1500:2341,1000:1621,750:1249}, 630:{1500:null,1000:2251,750:1734}, 710:{1500:null,1000:3338,750:2573} },
  14: { 112:{1500:18.5,1000:12.5,750:9.8}, 125:{1500:25,1000:17.5,750:13}, 140:{1500:36,1000:25,750:19}, 160:{1500:52.5,1000:36,750:27.6}, 180:{1500:74,1000:51,750:39}, 200:{1500:105,1000:73,750:56}, 224:{1500:148,1000:102,750:79}, 250:{1500:206,1000:142,750:110}, 280:{1500:279,1000:193,750:149}, 315:{1500:404,1000:280,750:216}, 355:{1500:555,1000:384,750:296}, 400:{1500:779,1000:540,750:416}, 450:{1500:1115,1000:772,750:594}, 500:{1500:1485,1000:1028,750:792}, 560:{1500:2162,1000:1455,750:1120}, 630:{1500:2918,1000:2020,750:1555}, 710:{1500:4318,1000:2996,750:2310} },
  16: { 112:{1500:16,1000:11,750:8}, 125:{1500:22,1000:15,750:11.5}, 140:{1500:31,1000:21.5,750:17}, 160:{1500:47.5,1000:32,750:25}, 180:{1500:70.5,1000:49,750:38}, 200:{1500:98,1000:68,750:53}, 224:{1500:133,1000:92,750:71}, 250:{1500:185,1000:128,750:99}, 280:{1500:251,1000:174,750:134}, 315:{1500:362,1000:251,750:193}, 355:{1500:498,1000:345,750:266}, 400:{1500:700,1000:484,750:373}, 450:{1500:1000,1000:693,750:533}, 500:{1500:1333,1000:923,750:711}, 560:{1500:1887,1000:1306,750:1005}, 630:{1500:2619,1000:1812,750:1395}, 710:{1500:3879,1000:2690,750:2073} },
  18: { 112:{1500:14,1000:10,750:7.5}, 125:{1500:19.5,1000:13.5,750:10.5}, 140:{1500:28,1000:19.6,750:15}, 160:{1500:42.5,1000:29,750:22}, 180:{1500:60.5,1000:42,750:32}, 200:{1500:86,1000:59.5,750:46}, 224:{1500:115,1000:80,750:61}, 250:{1500:161,1000:111,750:86}, 280:{1500:225,1000:156,750:120}, 315:{1500:326,1000:226,750:174}, 355:{1500:448,1000:310,750:239}, 400:{1500:629,1000:435,750:335}, 450:{1500:899,1000:622,750:479}, 500:{1500:1197,1000:829,750:638}, 560:{1500:1697,1000:1175,750:905}, 630:{1500:2353,1000:1628,750:1252}, 710:{1500:3487,1000:2417,750:1861} },
  20: { 112:{1500:13,1000:9,750:6.8}, 125:{1500:18,1000:12,750:9.5}, 140:{1500:25.5,1000:18,750:14}, 160:{1500:38,1000:26.5,750:20}, 180:{1500:59,1000:41,750:32}, 200:{1500:77,1000:53.5,750:41}, 224:{1500:103,1000:72,750:55}, 250:{1500:142,1000:95,750:76}, 280:{1500:205,1000:142,750:109}, 315:{1500:296,1000:205,750:158}, 355:{1500:418,1000:279,750:210}, 400:{1500:587,1000:392,750:295}, 450:{1500:839,1000:560,750:420}, 500:{1500:1120,1000:746,750:562}, 560:{1500:1580,1000:1050,750:735}, 630:{1500:2200,1000:1460,750:1120}, 710:{1500:3260,1000:2170,750:1635} },
};

export const PN_ZSY = {
  22.4: { 160:{1500:34,1000:24,750:18}, 180:{1500:51,1000:35,750:27}, 200:{1500:68,1000:48,750:37}, 224:{1500:98,1000:68,750:52}, 250:{1500:131,1000:91,750:70}, 280:{1500:182,1000:128,750:97}, 315:{1500:270,1000:185,750:135}, 355:{1500:400,1000:262,750:215}, 400:{1500:530,1000:355,750:275}, 450:{1500:780,1000:540,750:415}, 500:{1500:1065,1000:750,750:580}, 560:{1500:1450,1000:1025,750:800}, 630:{1500:1865,1000:1325,750:1030}, 710:{1500:null,1000:1905,750:1485} },
  25: { 160:{1500:32,1000:22,750:16}, 180:{1500:46,1000:31,750:24}, 200:{1500:63,1000:43,750:33}, 224:{1500:96,1000:66,750:51}, 250:{1500:115,1000:80,750:60}, 280:{1500:157,1000:108,750:84}, 315:{1500:240,1000:163,750:122}, 355:{1500:365,1000:250,750:195}, 400:{1500:470,1000:315,750:240}, 450:{1500:705,1000:465,750:350}, 500:{1500:1020,1000:705,750:540}, 560:{1500:1405,1000:975,750:750}, 630:{1500:1865,1000:1325,750:1030}, 710:{1500:null,1000:1905,750:1485} },
  28: { 160:{1500:29,1000:20,750:15}, 180:{1500:42,1000:29,750:22}, 200:{1500:59,1000:41,750:31}, 224:{1500:86,1000:60,750:46}, 250:{1500:113,1000:75,750:56}, 280:{1500:142,1000:98,750:76}, 315:{1500:220,1000:148,750:114}, 355:{1500:325,1000:215,750:160}, 400:{1500:425,1000:280,750:210}, 450:{1500:625,1000:420,750:310}, 500:{1500:945,1000:650,750:500}, 560:{1500:1260,1000:870,750:670}, 630:{1500:1800,1000:1245,750:960}, 710:{1500:null,1000:1760,750:1355} },
  31.5: { 160:{1500:26,1000:17,750:14}, 180:{1500:37,1000:26,750:20}, 200:{1500:51,1000:35,750:27}, 224:{1500:79,1000:55,750:42}, 250:{1500:95,1000:63,750:49}, 280:{1500:127,1000:86,750:65}, 315:{1500:197,1000:132,750:100}, 355:{1500:290,1000:195,750:145}, 400:{1500:395,1000:270,750:200}, 450:{1500:560,1000:370,750:280}, 500:{1500:840,1000:585,750:450}, 560:{1500:1140,1000:790,750:605}, 630:{1500:1600,1000:1110,750:855}, 710:{1500:null,1000:1565,750:1200} },
  35.5: { 160:{1500:23,1000:15,750:12}, 180:{1500:34,1000:23,750:18}, 200:{1500:47,1000:32,750:25}, 224:{1500:70,1000:48,750:37}, 250:{1500:88,1000:59,750:44}, 280:{1500:117,1000:80,750:61}, 315:{1500:178,1000:118,750:90}, 355:{1500:275,1000:180,750:140}, 400:{1500:350,1000:235,750:175}, 450:{1500:510,1000:340,750:255}, 500:{1500:755,1000:520,750:405}, 560:{1500:1025,1000:710,750:545}, 630:{1500:1450,1000:1000,750:750}, 710:{1500:null,1000:1410,750:1090} },
  40: { 160:{1500:21,1000:17,750:11}, 180:{1500:30,1000:21,750:16}, 200:{1500:42,1000:29,750:22}, 224:{1500:64,1000:40,750:31}, 250:{1500:79,1000:53,750:41}, 280:{1500:107,1000:77,750:55}, 315:{1500:158,1000:108,750:80}, 355:{1500:235,1000:160,750:125}, 400:{1500:325,1000:210,750:155}, 450:{1500:465,1000:315,750:235}, 500:{1500:675,1000:465,750:360}, 560:{1500:930,1000:640,750:495}, 630:{1500:1300,1000:900,750:680}, 710:{1500:null,1000:1315,750:1015} },
  45: { 160:{1500:17,1000:12,750:9}, 180:{1500:24,1000:16,750:12}, 200:{1500:34,1000:24,750:18}, 224:{1500:46,1000:32,750:25}, 250:{1500:70,1000:47,750:36}, 280:{1500:96,1000:64,750:50}, 315:{1500:142,1000:95,750:74}, 355:{1500:215,1000:145,750:110}, 400:{1500:280,1000:185,750:140}, 450:{1500:410,1000:280,750:210}, 500:{1500:615,1000:425,750:320}, 560:{1500:850,1000:590,750:450}, 630:{1500:1130,1000:770,750:600}, 710:{1500:null,1000:1150,750:885} },
  50: { 160:{1500:15,1000:11,750:8}, 180:{1500:22,1000:15,750:12}, 200:{1500:32,1000:22,750:17}, 224:{1500:46,1000:31,750:24}, 250:{1500:63,1000:43,750:32}, 280:{1500:85,1000:59,750:43}, 315:{1500:128,1000:95,750:65}, 355:{1500:195,1000:130,750:95}, 400:{1500:245,1000:165,750:125}, 450:{1500:360,1000:240,750:180}, 500:{1500:540,1000:370,750:290}, 560:{1500:750,1000:520,750:400}, 630:{1500:1030,1000:710,750:550}, 710:{1500:1490,1000:1030,750:795} },
  56: { 160:{1500:15,1000:10,750:8}, 180:{1500:21,1000:15,750:11}, 200:{1500:31,1000:22,750:17}, 224:{1500:43,1000:30,750:23}, 250:{1500:56,1000:38,750:28}, 280:{1500:76,1000:52,750:40}, 315:{1500:112,1000:77,750:58}, 355:{1500:170,1000:115,750:90}, 400:{1500:220,1000:145,750:110}, 450:{1500:310,1000:210,750:160}, 500:{1500:480,1000:330,750:255}, 560:{1500:675,1000:470,750:360}, 630:{1500:955,1000:660,750:510}, 710:{1500:1340,1000:930,750:715} },
  63: { 160:{1500:12,1000:8,750:6}, 180:{1500:17,1000:12,750:9}, 200:{1500:23,1000:16,750:12}, 224:{1500:37,1000:25,750:20}, 250:{1500:45,1000:30,750:23}, 280:{1500:61,1000:42,750:32}, 315:{1500:102,1000:70,750:52}, 355:{1500:145,1000:100,750:75}, 400:{1500:195,1000:130,750:100}, 450:{1500:280,1000:190,750:140}, 500:{1500:425,1000:290,750:225}, 560:{1500:605,1000:420,750:325}, 630:{1500:860,1000:600,750:460}, 710:{1500:1170,1000:810,750:620} },
  71: { 160:{1500:11,1000:8,750:6}, 180:{1500:17,1000:11,750:9}, 200:{1500:23,1000:15,750:12}, 224:{1500:33,1000:23,750:18}, 250:{1500:40,1000:27,750:21}, 280:{1500:56,1000:38,750:29}, 315:{1500:90,1000:60,750:45}, 355:{1500:130,1000:90,750:65}, 400:{1500:185,1000:115,750:90}, 450:{1500:245,1000:170,750:125}, 500:{1500:390,1000:270,750:210}, 560:{1500:540,1000:370,750:285}, 630:{1500:770,1000:540,750:410}, 710:{1500:1045,1000:725,750:555} },
  80: { 160:{1500:9,1000:6,750:4}, 180:{1500:13,1000:9,750:7}, 200:{1500:18,1000:12,750:10}, 224:{1500:26,1000:18,750:14}, 250:{1500:36,1000:24,750:19}, 280:{1500:51,1000:34,750:27}, 315:{1500:80,1000:54,750:42}, 355:{1500:115,1000:80,750:60}, 400:{1500:155,1000:100,750:80}, 450:{1500:225,1000:150,750:110}, 500:{1500:340,1000:240,750:185}, 560:{1500:470,1000:330,750:250}, 630:{1500:675,1000:470,750:360}, 710:{1500:960,1000:665,750:510} },
  90: { 160:{1500:8,1000:6,750:4}, 180:{1500:12,1000:8,750:6}, 200:{1500:18,1000:12,750:9}, 224:{1500:25,1000:17,750:13}, 250:{1500:33,1000:22,750:17}, 280:{1500:46,1000:30,750:23}, 315:{1500:74,1000:49,750:37}, 355:{1500:105,1000:70,750:55}, 400:{1500:140,1000:95,750:70}, 450:{1500:200,1000:130,750:100}, 500:{1500:305,1000:200,750:160}, 560:{1500:395,1000:278,750:210}, 630:{1500:590,1000:405,750:300}, 710:{1500:765,1000:530,750:405} },
  100: { 160:{1500:8,1000:5,750:4}, 180:{1500:11,1000:7,750:6}, 200:{1500:16,1000:11,750:8}, 224:{1500:24,1000:16,750:13}, 250:{1500:30,1000:21,750:16}, 280:{1500:43,1000:29,750:22}, 315:{1500:60,1000:40,750:30} },
};

export const PN_ZFY = {
  100: { 355:{1500:94,1000:64,750:49}, 400:{1500:123,1000:84,750:64}, 450:{1500:180,1000:121,750:92}, 500:{1500:283,1000:190,750:144}, 560:{1500:395,1000:264,750:200}, 630:{1500:515,1000:345,750:260}, 710:{1500:770,1000:520,750:400} },
  112: { 180:{1500:9.1,1000:6.0,750:4.5}, 200:{1500:15,1000:10,750:7.6}, 224:{1500:20,1000:14.5,750:11.3}, 250:{1500:28.5,1000:20,750:15}, 280:{1500:40.5,1000:28.4,750:21.5}, 315:{1500:52.3,1000:36.2,750:27.3}, 355:{1500:81,1000:55,750:42}, 400:{1500:110,1000:75,750:57}, 450:{1500:156,1000:105,750:80}, 500:{1500:250,1000:168,750:127}, 560:{1500:355,1000:238,750:180}, 630:{1500:465,1000:312,750:235}, 710:{1500:690,1000:465,750:350} },
  125: { 180:{1500:9.1,1000:6.0,750:4.5}, 200:{1500:12,1000:8,750:6}, 224:{1500:18,1000:12,750:9}, 250:{1500:25,1000:17.5,750:13.5}, 280:{1500:36,1000:25,750:19}, 315:{1500:48.9,1000:32.9,750:25.3}, 355:{1500:75,1000:51,750:39}, 400:{1500:98,1000:67,750:51}, 450:{1500:137,1000:92,750:69.5}, 500:{1500:225,1000:151,750:114}, 560:{1500:315,1000:212,750:160}, 630:{1500:410,1000:275,750:208}, 710:{1500:600,1000:403,750:305} },
  140: { 180:{1500:8.1,1000:5.5,750:4.1}, 200:{1500:11,1000:7,750:5.6}, 224:{1500:16,1000:11,750:8.2}, 250:{1500:23,1000:16,750:12}, 280:{1500:31,1000:21,750:16}, 315:{1500:43.8,1000:29.4,750:22.2}, 355:{1500:68,1000:46,750:35}, 400:{1500:87,1000:59,750:45}, 450:{1500:129.5,1000:87,750:66}, 500:{1500:205,1000:138,750:105}, 560:{1500:280,1000:189,750:143}, 630:{1500:376,1000:252,750:190}, 710:{1500:545,1000:365,750:275} },
  160: { 180:{1500:7.4,1000:5,750:3.6}, 200:{1500:9.5,1000:6.3,750:4.7}, 224:{1500:14,1000:9.7,750:7.6}, 250:{1500:20,1000:14.5,750:11}, 280:{1500:27,1000:18.5,750:14}, 315:{1500:39,1000:26.2,750:19.8}, 355:{1500:59.5,1000:40.5,750:30}, 400:{1500:75,1000:51,750:39.5}, 450:{1500:117,1000:78.5,750:59.5}, 500:{1500:175,1000:118,750:90}, 560:{1500:252,1000:169,750:128}, 630:{1500:335,1000:225,750:170}, 710:{1500:490,1000:328,750:248} },
  180: { 180:{1500:6.5,1000:4.2,750:3.3}, 200:{1500:8.4,1000:5.5,750:4.2}, 224:{1500:12.7,1000:8.5,750:6.4}, 250:{1500:19,1000:13,750:9.8}, 280:{1500:25,1000:17,750:12.5}, 315:{1500:35.1,1000:24,750:17.8}, 355:{1500:50,1000:34,750:26.5}, 400:{1500:66,1000:45,750:35}, 450:{1500:101,1000:68,750:51.5}, 500:{1500:158,1000:106,750:81}, 560:{1500:223,1000:150,750:114}, 630:{1500:303,1000:204,750:154}, 710:{1500:435,1000:291,750:219} },
  200: { 180:{1500:5.5,1000:3.7,750:2.7}, 200:{1500:7.5,1000:5,750:3.8}, 224:{1500:11.5,1000:8,750:6}, 250:{1500:15,1000:10,750:7.5}, 280:{1500:22,1000:14.8,750:11.4}, 315:{1500:31.5,1000:21.2,750:16.2}, 355:{1500:48,1000:33,750:25}, 400:{1500:62,1000:42,750:32}, 450:{1500:91,1000:61,750:46.5}, 500:{1500:138,1000:93,750:70}, 560:{1500:200,1000:134,750:101}, 630:{1500:270,1000:182,750:137}, 710:{1500:385,1000:258,750:195} },
  224: { 180:{1500:4.8,1000:3.1,750:2.3}, 200:{1500:6.7,1000:4.4,750:3.4}, 224:{1500:10.1,1000:6.9,750:5.2}, 250:{1500:14,1000:9.4,750:7.3}, 280:{1500:20,1000:14,750:10.5}, 315:{1500:28,1000:18.9,750:14.3}, 355:{1500:43,1000:29,750:22.5}, 400:{1500:55,1000:37,750:28}, 450:{1500:79,1000:53,750:40.5}, 500:{1500:121.5,1000:82,750:62}, 560:{1500:184,1000:123,750:93}, 630:{1500:235,1000:158,750:120}, 710:{1500:350,1000:235,750:178} },
  250: { 180:{1500:4.5,1000:3,750:2.1}, 200:{1500:6.0,1000:4.0,750:3.0}, 224:{1500:9.5,1000:6.4,750:4.9}, 250:{1500:12.4,1000:8.4,750:6.4}, 280:{1500:17,1000:11.5,750:8.7}, 315:{1500:24.9,1000:17,750:12.9}, 355:{1500:38,1000:26,750:20.2}, 400:{1500:49,1000:33,750:25}, 450:{1500:70,1000:47,750:36}, 500:{1500:110,1000:74,750:56}, 560:{1500:161,1000:108,750:82}, 630:{1500:215,1000:145,750:110}, 710:{1500:315,1000:210,750:158} },
  280: { 180:{1500:3.9,1000:2.7,750:2}, 200:{1500:5.2,1000:3.5,750:2.6}, 224:{1500:8.2,1000:5.5,750:4.2}, 250:{1500:11,1000:7.4,750:5.6}, 280:{1500:15,1000:10.4,750:7.9}, 315:{1500:22,1000:14.8,750:11.2}, 355:{1500:35,1000:23.8,750:18.3}, 400:{1500:43,1000:29,750:22}, 450:{1500:64,1000:43,750:32.5}, 500:{1500:97,1000:65,750:50}, 560:{1500:142,1000:95,750:72}, 630:{1500:185,1000:125,750:95}, 710:{1500:278,1000:186,750:140} },
  315: { 180:{1500:3.5,1000:2.2,750:1.8}, 200:{1500:4.5,1000:3.0,750:2.3}, 224:{1500:7.5,1000:5.0,750:3.8}, 250:{1500:9.3,1000:6.2,750:4.8}, 280:{1500:13.8,1000:9.2,750:7}, 315:{1500:19.5,1000:13,750:9.8}, 355:{1500:29,1000:20,750:15.5}, 400:{1500:38,1000:26,750:20}, 450:{1500:55,1000:37.5,750:28.5}, 500:{1500:92,1000:62,750:47}, 560:{1500:128,1000:86,750:65}, 630:{1500:167,1000:112,750:85}, 710:{1500:250,1000:167,750:126} },
  355: { 180:{1500:2.9,1000:1.5,750:1.5}, 200:{1500:4,1000:2.6,750:2}, 224:{1500:6.6,1000:4.5,750:3.4}, 250:{1500:8.5,1000:5.7,750:4.3}, 280:{1500:11.5,1000:7.8,750:6}, 315:{1500:17.3,1000:11.7,750:8.9}, 355:{1500:26,1000:18,750:13.9}, 400:{1500:35,1000:23.5,750:18}, 450:{1500:49,1000:33,750:25.5}, 500:{1500:80,1000:54,750:41}, 560:{1500:112,1000:75,750:57}, 630:{1500:147,1000:99,750:75}, 710:{1500:223,1000:150,750:113} },
  400: { 180:{1500:2.5,1000:1.5,750:1.2}, 200:{1500:3.5,1000:2.3,750:1.8}, 224:{1500:6,1000:4,750:3}, 250:{1500:8,1000:5.5,750:4}, 280:{1500:11,1000:7.5,750:5.6}, 315:{1500:15.6,1000:10.5,750:8}, 355:{1500:24,1000:16.3,750:12.8}, 400:{1500:32,1000:21.5,750:16.5}, 450:{1500:43,1000:29,750:22}, 500:{1500:68,1000:46,750:35}, 560:{1500:100,1000:67,750:51}, 630:{1500:128,1000:86,750:65}, 710:{1500:190,1000:128,750:97} },
  450: { 180:{1500:2.3,1000:1.5,750:1.2}, 200:{1500:3.2,1000:2.0,750:1.7}, 224:{1500:5,1000:3.4,750:2.6}, 250:{1500:7,1000:4.8,750:3.6}, 280:{1500:9.7,1000:6.5,750:5}, 315:{1500:13,1000:8.7,750:6.6}, 355:{1500:20,1000:13.7,750:10.4}, 400:{1500:27.3,1000:18.5,750:14.2}, 450:{1500:38.5,1000:26,750:20}, 500:{1500:64,1000:43,750:32.5}, 560:{1500:88,1000:59,750:45}, 630:{1500:121,1000:82,750:62}, 710:{1500:176,1000:118,750:89} },
  500: { 180:{1500:2.1,1000:1.3,750:1.1}, 200:{1500:2.8,1000:1.85,750:1.4}, 224:{1500:4.3,1000:2.9,750:2.1}, 250:{1500:6.1,1000:4.1,750:3.1}, 280:{1500:8.7,1000:5.9,750:4.5}, 315:{1500:11.5,1000:7.8,750:5.9}, 355:{1500:18.5,1000:12.5,750:9.5}, 400:{1500:24.5,1000:16.5,750:12.5}, 450:{1500:35,1000:23.5,750:17.8}, 500:{1500:55,1000:37,750:28}, 560:{1500:80,1000:54,750:41}, 630:{1500:104,1000:70,750:53}, 710:{1500:152,1000:102,750:77} },
};

const PN_MAP = { ZDY: PN_ZDY, ZLY: PN_ZLY, ZSY: PN_ZSY, ZFY: PN_ZFY };

/** คืนค่า P1N (kW) ตาม Series/Size/Ratio/Input Speed หรือ null ถ้าไม่มีข้อมูล */
export function getZPN(zType, zSize, zRatio, n1) {
  if (!zType || !zSize || !zRatio || !n1) return null;
  const table = PN_MAP[zType];
  if (!table) return null;
  const row = table[Number(zRatio)];
  if (!row) return null;
  const cell = row[Number(zSize)];
  if (!cell) return null;
  const v = cell[Number(n1)];
  return (v == null) ? null : Number(v);
}

/** คำนวณ Service Factor = P1N / kW มอเตอร์ → { PN, SF } (null ถ้าข้อมูลไม่พอ) */
export function calcZSF(zType, zSize, zRatio, n1, kW) {
  const PN = getZPN(zType, zSize, zRatio, n1);
  const kw = parseFloat(kW);
  if (PN == null || !Number.isFinite(kw) || kw <= 0) return { PN, SF: null };
  return { PN, SF: PN / kw };
}

// ─────────────────────────────────────────────────────────────────────────────
// Code generator
// ─────────────────────────────────────────────────────────────────────────────
export function generateZModelCode(state = {}) {
  const { zType, zSize, zRatio, zAssembly } = state;
  if (!zType) return '';
  const parts = [zType];
  if (zSize)     parts.push(String(zSize));
  if (zRatio)    parts.push(String(zRatio));
  if (zAssembly) parts.push(String(zAssembly));
  return parts.join('-');
}

// ─────────────────────────────────────────────────────────────────────────────
// Animation variants
// ─────────────────────────────────────────────────────────────────────────────
const pageVariants = {
  initial: { opacity: 0, x: 40 },
  animate: { opacity: 1, x: 0,  transition: { duration: 0.28, ease: 'easeOut' } },
  exit:    { opacity: 0, x: -40, transition: { duration: 0.18, ease: 'easeIn'  } },
};

const itemVariants = {
  hidden:  { opacity: 0, y: 18, scale: 0.95 },
  visible: (i) => ({ opacity: 1, y: 0, scale: 1, transition: { delay: i * 0.045, duration: 0.22, ease: 'easeOut' } }),
};

// ─────────────────────────────────────────────────────────────────────────────
// Sub-components
// ─────────────────────────────────────────────────────────────────────────────

/** 3-D image tile button — ไม่มีกรอบ ภาพใหญ่ มุมโค้ง label ห้อยใต้ */
const Tile3D = ({ img, label, onClick, selected }) => {
  const [pressing, setPressing] = useState(false);
  return (
    <button
      type="button"
      onPointerDown={() => setPressing(true)}
      onPointerUp={() => { setPressing(false); onClick && onClick(); }}
      onPointerLeave={() => setPressing(false)}
      className={`
        flex flex-col items-center gap-2 bg-transparent border-none outline-none
        transition-all duration-150 select-none
        ${pressing ? 'scale-90 brightness-90' : 'hover:-translate-y-1 active:scale-95'}
        ${selected ? 'opacity-100' : 'opacity-90 hover:opacity-100'}
      `}
      style={{ cursor: 'pointer' }}
    >
      {img && (
        <img
          src={img}
          alt={label}
          className="object-cover card-image select-none"
          style={{
            width: '100%',
            height: '160px',
            borderRadius: '12px',
            boxShadow: pressing
              ? '0 2px 8px rgba(0,0,0,0.3)'
              : '0 6px 20px rgba(0,0,0,0.35)',
            transition: 'box-shadow 0.15s',
          }}
          draggable={false}
        />
      )}
      <span className="text-sm font-bold text-white drop-shadow">{label}</span>
    </button>
  );
};

/** Number / text pill button (Size & Ratio) */
const PillBtn = ({ label, onClick, selected }) => {
  const [pressing, setPressing] = useState(false);
  return (
    <button
      type="button"
      onPointerDown={() => setPressing(true)}
      onPointerUp={() => { setPressing(false); onClick && onClick(); }}
      onPointerLeave={() => setPressing(false)}
      className={`
        relative rounded-xl px-3 py-2 text-sm font-bold shadow-md
        border border-white/20 backdrop-blur-sm
        transition-all duration-150 select-none
        ${pressing
          ? 'scale-90 shadow-inner translate-y-0.5 brightness-90'
          : 'hover:-translate-y-0.5 hover:shadow-lg active:scale-95'}
        ${selected
          ? 'bg-blue-500 text-white ring-2 ring-blue-300 scale-105'
          : 'bg-white/20 text-white hover:bg-white/30'}
      `}
      style={{
        boxShadow: pressing
          ? 'inset 0 2px 6px rgba(0,0,0,0.35)'
          : '0 4px 10px rgba(0,0,0,0.25), 0 1px 0 rgba(255,255,255,0.15) inset',
      }}
    >
      {label}
    </button>
  );
};

/** Breadcrumb / step tracker bar */
const Breadcrumb = ({ steps, onJump }) => (
  <div className="flex flex-wrap items-center gap-1 text-xs text-white/80 mb-2 select-none">
    {steps.map((s, i) => (
      <React.Fragment key={i}>
        {i > 0 && <span className="text-white/40">›</span>}
        <button
          type="button"
          onClick={() => s.active && onJump(s.key)}
          className={`px-2 py-0.5 rounded-full transition
            ${s.done
              ? 'bg-blue-500/70 text-white cursor-pointer hover:bg-blue-400'
              : s.current
                ? 'bg-white/30 text-white font-bold cursor-default'
                : 'bg-white/10 text-white/40 cursor-default'}`}
        >
          {s.label}
        </button>
      </React.Fragment>
    ))}
  </div>
);

/** Back button (bottom-left) */
const BackBtn = ({ onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className="fixed z-30 px-2 py-1 rounded-lg text-xs text-white/80
               bg-black/30 backdrop-blur-sm border border-white/20 shadow
               hover:text-white hover:bg-blue-500/70 hover:shadow-lg
               active:scale-95 transition-all duration-200"
    style={{ left: 'max(1rem, env(safe-area-inset-left))', bottom: 'max(1rem, env(safe-area-inset-bottom))' }}
  >
    ← ย้อนกลับ
  </button>
);

/** Home button (top-right) — SVG icon */
const HomeBtn = ({ onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className="fixed z-30 w-8 h-8 rounded-full flex items-center justify-center
               bg-black/25 backdrop-blur-sm border border-white/20 shadow
               text-white/70 hover:text-white hover:bg-blue-500 hover:shadow-lg
               active:scale-95 transition-all duration-200"
    style={{ right: 'max(1rem, env(safe-area-inset-right))', top: 'max(1rem, env(safe-area-inset-top))' }}
    title="กลับหน้าหลัก"
  >
    <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" viewBox="0 0 20 20" fill="currentColor">
      <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7A1 1 0 003 11h1v6a1 1 0 001 1h4v-4h2v4h4a1 1 0 001-1v-6h1a1 1 0 00.707-1.707l-7-7z" />
    </svg>
  </button>
);

// ─────────────────────────────────────────────────────────────────────────────
// Main render function
// ─────────────────────────────────────────────────────────────────────────────
export function renderZSeriesFlow({ zState = {}, zSetters = {}, onHome, onSubmit }) {
  return (
    <ZSeriesFlow
      zState={zState}
      zSetters={zSetters}
      onHome={onHome}
      onSubmit={onSubmit}
    />
  );
}

function ZSeriesFlow({ zState, zSetters, onHome, onSubmit }) {
  const S = zState || {};
  const { zType, zSize, zRatio, zInputSpeed, zMotorKW, zAssembly } = S;

  // Lightbox state for Astype image
  const [lightbox, setLightbox] = useState(false);

  // Draft ของ kW ที่ผู้ใช้กำลังพิมพ์ (ยังไม่ commit จนกว่าจะกดยืนยัน)
  const [motorKwDraft, setMotorKwDraft] = useState('');

  // ลำดับ step ทั้งหมด — ใช้ทั้งใน goBack / reset-downstream / breadcrumb
  const STEP_ORDER = ['zType','zSize','zRatio','zInputSpeed','zMotorKW','zAssembly'];

  // ── updater ────────────────────────────────────────────────────────────────
  const update = useCallback((key, value) => {
    if (key === 'goBack') {
      const order = STEP_ORDER;
      let lastIdx = -1;
      for (let i = order.length - 1; i >= 0; i--) {
        if (S[order[i]] != null && S[order[i]] !== '') { lastIdx = i; break; }
      }
      if (lastIdx >= 0) {
        for (let i = lastIdx; i < order.length; i++) {
          const fn = zSetters[`set${order[i].charAt(0).toUpperCase()}${order[i].slice(1)}`];
          if (typeof fn === 'function') fn(null);
        }
      }
      return;
    }
    // Reset downstream when going back to an earlier step
    const order = STEP_ORDER;
    const idx = order.indexOf(key);
    if (idx >= 0) {
      for (let i = idx; i < order.length; i++) {
        const fn = zSetters[`set${order[i].charAt(0).toUpperCase()}${order[i].slice(1)}`];
        if (typeof fn === 'function') fn(i === idx ? value : null);
      }
      return;
    }
    const fn = zSetters[`set${key.charAt(0).toUpperCase()}${key.slice(1)}`];
    if (typeof fn === 'function') fn(value);
  }, [S, zSetters]);

  const resetAll = useCallback(() => {
    STEP_ORDER.forEach(k => {
      const fn = zSetters[`set${k.charAt(0).toUpperCase()}${k.slice(1)}`];
      if (typeof fn === 'function') fn(null);
    });
  }, [zSetters]);

  const goHome = useCallback(() => { resetAll(); if (typeof onHome === 'function') onHome(); }, [resetAll, onHome]);

  // ── breadcrumb builder ─────────────────────────────────────────────────────
  const buildBreadcrumbs = () => {
    const code = generateZModelCode(S);
    const crumbs = [
      { key: 'zType',       label: zType    ? `Type: ${zType}`                          : 'Type',              done: !!zType,     current: !zType },
      { key: 'zSize',       label: zSize    ? `Size: ${zSize}`                          : 'Size',              done: !!zSize,     current: !!zType && !zSize },
      { key: 'zRatio',      label: zRatio   ? `Ratio: ${zRatio}`                        : 'Ratio',             done: !!zRatio,    current: !!zSize && !zRatio },
      { key: 'zInputSpeed', label: zMotorKW ? `Motor: ${zInputSpeed}rpm / ${zMotorKW}kW` : 'Input Speed & Motor', done: !!zMotorKW, current: !!zRatio && !zMotorKW },
      { key: 'zAssembly',   label: zAssembly ? `Assembly: ${zAssembly}`                  : 'Assembly Type',     done: !!zAssembly, current: !!zMotorKW && !zAssembly },
    ];
    if (code) crumbs.push({ key: 'code', label: `Code: ${code}`, done: false, current: false, active: false });
    return crumbs.map(c => ({ ...c, active: c.done }));
  };

  const pageKey = zAssembly ? 'summary' : zMotorKW ? 'assembly' : zRatio ? 'motor' : zSize ? 'ratio' : zType ? 'size' : 'type';

  // ─────────────────────────────────────────────────────────────────────────
  // STEP 1 — Type
  // ─────────────────────────────────────────────────────────────────────────
  if (!zType) {
    return (
      <div className="space-y-3 mt-0">
        <HomeBtn onClick={goHome} />
        <Breadcrumb steps={buildBreadcrumbs()} onJump={(k) => update(k, null)} />
        <h3 className="text-white font-bold drop-shadow">Z Series — เลือกประเภท</h3>
        <AnimatePresence mode="wait">
          <motion.div key="step-type" variants={pageVariants} initial="initial" animate="animate" exit="exit"
            className="grid grid-cols-2 sm:grid-cols-4 gap-3 justify-items-center">
            {Z_TYPES.map((t, i) => (
              <motion.div key={t.key} custom={i} variants={itemVariants} initial="hidden" animate="visible">
                <Tile3D img={t.img} label={t.label} onClick={() => update('zType', t.key)} />
              </motion.div>
            ))}
          </motion.div>
        </AnimatePresence>
      </div>
    );
  }

  // ─────────────────────────────────────────────────────────────────────────
  // STEP 2 — Size
  // ─────────────────────────────────────────────────────────────────────────
  if (zType && !zSize) {
    const sizeList = SIZES[zType] || [];
    return (
      <div className="space-y-3 mt-0">
        <HomeBtn onClick={goHome} />
        <BackBtn onClick={() => update('goBack', null)} />
        <Breadcrumb steps={buildBreadcrumbs()} onJump={(k) => update(k, null)} />
        <h3 className="text-white font-bold drop-shadow">{zType} — เลือก Size</h3>
        <AnimatePresence mode="wait">
          <motion.div key="step-size" variants={pageVariants} initial="initial" animate="animate" exit="exit"
            className="flex flex-wrap gap-2 justify-start">
            {sizeList.map((sz, i) => (
              <motion.div key={sz} custom={i} variants={itemVariants} initial="hidden" animate="visible">
                <PillBtn label={String(sz)} onClick={() => update('zSize', sz)} selected={zSize === sz} />
              </motion.div>
            ))}
          </motion.div>
        </AnimatePresence>
      </div>
    );
  }

  // ─────────────────────────────────────────────────────────────────────────
  // STEP 3 — Ratio
  // ─────────────────────────────────────────────────────────────────────────
  if (zType && zSize && !zRatio) {
    const ratioMap = RATIOS_MAP[zType];
    const ratioList = ratioMap ? (ratioMap[zSize] || []) : null;

    return (
      <div className="space-y-3 mt-0">
        <HomeBtn onClick={goHome} />
        <BackBtn onClick={() => update('goBack', null)} />
        <Breadcrumb steps={buildBreadcrumbs()} onJump={(k) => update(k, null)} />
        <h3 className="text-white font-bold drop-shadow">{zType}-{zSize} — เลือก Ratio</h3>
        <AnimatePresence mode="wait">
          <motion.div key="step-ratio" variants={pageVariants} initial="initial" animate="animate" exit="exit">
            {ratioList && ratioList.length > 0 ? (
              <div className="flex flex-wrap gap-2 justify-start">
                {ratioList.map((r, i) => (
                  <motion.div key={r} custom={i} variants={itemVariants} initial="hidden" animate="visible">
                    <PillBtn label={String(r)} onClick={() => update('zRatio', r)} selected={zRatio === r} />
                  </motion.div>
                ))}
              </div>
            ) : (
              <div className="rounded-xl bg-yellow-400/20 border border-yellow-300/40 text-yellow-200 p-4 text-sm">
                ⚠️ ข้อมูล Ratio ของ <strong>{zType}</strong> ยังไม่ได้กำหนด — TODO: เพิ่ม RATIOS_{zType} ใน ZSeriesFlow.js
              </div>
            )}
          </motion.div>
        </AnimatePresence>
      </div>
    );
  }

  // ─────────────────────────────────────────────────────────────────────────
  // STEP 3.5 — Input Speed + Motor kW → Service Factor
  // ─────────────────────────────────────────────────────────────────────────
  if (zType && zSize && zRatio && !zMotorKW) {
    const INPUT_SPEEDS = [1500, 1000, 750];
    const draftKw = parseFloat(motorKwDraft);
    const { PN, SF: sfPreview } = calcZSF(zType, zSize, zRatio, zInputSpeed, motorKwDraft);
    const canConfirm = !!zInputSpeed && Number.isFinite(draftKw) && draftKw > 0;
    const fmtV = (x) => (x || x === 0) ? x.toLocaleString(undefined, { maximumFractionDigits: 2 }) : '—';

    return (
      <div className="space-y-3 mt-0">
        <HomeBtn onClick={goHome} />
        <BackBtn onClick={() => update('goBack', null)} />
        <Breadcrumb steps={buildBreadcrumbs()} onJump={(k) => update(k, null)} />
        <h3 className="text-white font-bold drop-shadow">{zType}-{zSize}-{zRatio} — เลือก Input Speed และกรอกขนาดมอเตอร์</h3>

        <AnimatePresence mode="wait">
          <motion.div key="step-motor" variants={pageVariants} initial="initial" animate="animate" exit="exit" className="space-y-4">
            {/* Input Speed pills */}
            <div>
              <div className="text-white/70 text-sm mb-2">Input Speed (rpm)</div>
              <div className="flex flex-wrap gap-2 justify-start">
                {INPUT_SPEEDS.map((sp, i) => (
                  <motion.div key={sp} custom={i} variants={itemVariants} initial="hidden" animate="visible">
                    <PillBtn label={`${sp}`} onClick={() => update('zInputSpeed', sp)} selected={zInputSpeed === sp} />
                  </motion.div>
                ))}
              </div>
            </div>

            {/* Motor kW input + live Service Factor preview */}
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
              <div className="rounded-2xl bg-white/10 border border-white/15 p-4 lg:col-span-1">
                <label className="text-white/70 text-sm">ขนาดมอเตอร์ (kW)</label>
                <input
                  type="number" min="0" step="0.1"
                  value={motorKwDraft}
                  onChange={(e) => setMotorKwDraft(e.target.value)}
                  placeholder="เช่น 37"
                  className="mt-2 w-full rounded-xl bg-black/30 text-white px-3 py-2 outline-none border border-white/15 focus:border-blue-400/60"
                />
              </div>
              <div className="rounded-2xl bg-white/10 border border-white/15 p-4 lg:col-span-1">
                <div className="text-white/70 text-sm">Nominal Input Power (P1N)</div>
                <div className="text-2xl font-semibold text-white mt-1">{fmtV(PN)} <span className="text-sm text-white/50">kW</span></div>
              </div>
              <div className="rounded-2xl bg-white/10 border border-white/15 p-4 lg:col-span-1">
                <div className="text-white/70 text-sm">Service Factor (S.F.)</div>
                <div className="text-2xl font-semibold text-white mt-1">{fmtV(sfPreview)}</div>
                {PN != null && draftKw > 0 && (
                  <div className="text-white/50 text-xs mt-1">= {fmtV(PN)} / {fmtV(draftKw)}</div>
                )}
              </div>
            </div>

            {!zInputSpeed && (
              <div className="rounded-xl bg-yellow-400/20 border border-yellow-300/40 text-yellow-200 p-3 text-sm">
                ⚠️ กรุณาเลือก Input Speed ก่อนกรอกขนาดมอเตอร์
              </div>
            )}
            {zInputSpeed && draftKw > 0 && PN == null && (
              <div className="rounded-xl bg-yellow-400/20 border border-yellow-300/40 text-yellow-200 p-3 text-sm">
                ⚠️ ไม่พบข้อมูล P1N ของ {zType}-{zSize} ที่ Ratio {zRatio} @ {zInputSpeed} rpm
              </div>
            )}

            <div className="flex justify-end">
              <button
                type="button"
                disabled={!canConfirm}
                onClick={() => update('zMotorKW', motorKwDraft)}
                className={
                  "px-5 py-2 rounded-xl border " +
                  (canConfirm
                    ? "bg-green-500 text-white border-green-400 hover:bg-green-600"
                    : "bg-white/10 text-white/50 border-white/15 cursor-not-allowed")
                }
              >
                ถัดไป — เลือก Assembly Type
              </button>
            </div>
          </motion.div>
        </AnimatePresence>
      </div>
    );
  }

  // ─────────────────────────────────────────────────────────────────────────
  // STEP 4 — Assembly Type
  // ─────────────────────────────────────────────────────────────────────────
  if (zType && zSize && zRatio && zMotorKW && !zAssembly) {
    return (
      <div className="space-y-3 mt-0">
        <HomeBtn onClick={goHome} />
        <BackBtn onClick={() => update('goBack', null)} />
        <Breadcrumb steps={buildBreadcrumbs()} onJump={(k) => update(k, null)} />
        <h3 className="text-white font-bold drop-shadow">{zType}-{zSize}-{zRatio} — เลือก Assembly Type</h3>

        {/* Astype reference image — คลิกเพื่อขยาย */}
        <AnimatePresence mode="wait">
          <motion.div key="step-assembly" variants={pageVariants} initial="initial" animate="animate" exit="exit"
            className="space-y-3">
            <div className="flex justify-center">
              <motion.img
                src={AstypeImg}
                alt="Assembly Type Reference"
                className="rounded-xl shadow-lg cursor-zoom-in max-h-44 object-contain border border-white/20"
                whileHover={{ scale: 1.03 }}
                whileTap={{ scale: 0.97 }}
                onClick={() => setLightbox(true)}
                title="คลิกเพื่อขยาย"
              />
              <span className="absolute text-white/50 text-xs mt-1 select-none" style={{marginTop:'11.5rem'}}>แตะรูปเพื่อขยาย</span>
            </div>

            {/* Assembly type buttons */}
            <div className="grid grid-cols-3 sm:grid-cols-5 gap-3 justify-items-center">
              {ASSEMBLY_TYPES.map((at, i) => (
                <motion.div key={at} custom={i} variants={itemVariants} initial="hidden" animate="visible">
                  <PillBtn
                    label={at}
                    onClick={() => update('zAssembly', at)}
                    selected={zAssembly === at}
                  />
                </motion.div>
              ))}
            </div>
          </motion.div>
        </AnimatePresence>

        {/* Lightbox */}
        <AnimatePresence>
          {lightbox && (
            <motion.div
              key="lightbox"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-center justify-center p-4"
              onClick={() => setLightbox(false)}
            >
              <motion.div
                initial={{ scale: 0.85 }}
                animate={{ scale: 1 }}
                exit={{ scale: 0.85 }}
                className="relative"
                onClick={e => e.stopPropagation()}
              >
                <button
                  type="button"
                  onClick={() => setLightbox(false)}
                  className="absolute -top-3 -right-3 z-10 w-8 h-8 rounded-full bg-white/20 border border-white/30 text-white hover:bg-red-500 transition flex items-center justify-center font-bold shadow-lg"
                >
                  ✕
                </button>
                <img
                  src={AstypeImg}
                  alt="Assembly Type Reference"
                  className="rounded-2xl shadow-2xl max-h-[80vh] max-w-[90vw] object-contain"
                />
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    );
  }

  // ─────────────────────────────────────────────────────────────────────────
  // STEP 5 — Summary & Code
  // ─────────────────────────────────────────────────────────────────────────
  if (zType && zSize && zRatio && zAssembly) {
    const code = generateZModelCode(S);
    const { PN, SF: sf } = calcZSF(zType, zSize, zRatio, zInputSpeed, zMotorKW);
    const fmtV = (x) => (x || x === 0) ? x.toLocaleString(undefined, { maximumFractionDigits: 2 }) : '—';

    return (
      <div className="space-y-4 mt-0">
        <HomeBtn onClick={goHome} />
        <BackBtn onClick={() => update('goBack', null)} />
        <Breadcrumb steps={buildBreadcrumbs()} onJump={(k) => update(k, null)} />

        <AnimatePresence mode="wait">
          <motion.div key="step-summary" variants={pageVariants} initial="initial" animate="animate" exit="exit"
            className="space-y-4">

            {/* Code display */}
            <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1,   opacity: 1, transition: { delay: 0.1, type: 'spring', stiffness: 200 } }}
              className="rounded-2xl bg-white/10 backdrop-blur-md border border-white/20 shadow-xl p-5 text-center"
            >
              <p className="text-white/60 text-sm mb-1">Model Code</p>
              <p className="text-white font-extrabold text-3xl tracking-widest drop-shadow">{code}</p>
            </motion.div>

            {/* Detail table */}
            <div className="grid grid-cols-2 gap-3 text-white text-sm">
              {[
                { label: 'Series Type',     value: zType },
                { label: 'Size',            value: zSize },
                { label: 'Ratio',           value: zRatio },
                { label: 'Assembly',        value: zAssembly },
                { label: 'Input Speed (rpm)', value: zInputSpeed ?? '—' },
                { label: 'Motor power (kW)',  value: zMotorKW ?? '—' },
                { label: 'Nominal Input Power P1N (kW)', value: fmtV(PN) },
                { label: 'Service Factor (S.F.)', value: fmtV(sf) },
              ].map(({ label, value }, i) => (
                <motion.div
                  key={label}
                  custom={i}
                  variants={itemVariants}
                  initial="hidden"
                  animate="visible"
                  className="rounded-xl bg-white/10 border border-white/15 p-3"
                >
                  <p className="text-white/50 text-xs mb-0.5">{label}</p>
                  <p className="font-semibold">{value}</p>
                </motion.div>
              ))}
            </div>

            {/* Confirm button */}
            <motion.button
              type="button"
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0,  opacity: 1, transition: { delay: 0.35, type: 'spring', stiffness: 180 } }}
              whileHover={{ scale: 1.03, boxShadow: '0 8px 24px rgba(59,130,246,0.5)' }}
              whileTap={{ scale: 0.95 }}
              onClick={() => typeof onSubmit === 'function' && onSubmit(code, S)}
              className="w-full py-4 rounded-2xl font-bold text-lg tracking-wide
                         bg-gradient-to-r from-blue-500 to-blue-700
                         text-white shadow-xl border border-blue-300/30
                         active:brightness-90 transition-all duration-200"
              style={{ boxShadow: '0 6px 20px rgba(37,99,235,0.45), 0 1px 0 rgba(255,255,255,0.15) inset' }}
            >
              รับไฟล์ 3D .step
            </motion.button>
          </motion.div>
        </AnimatePresence>
      </div>
    );
  }

  return null;
}

export default ZSeriesFlow;
